export const CAPSULE_TYPES = {
  DISCOUNT: 'DISCOUNT',
  BREAKFAST: 'BREAKFAST',
  NEGOTIATED: 'NEGOTIATED',
  DEFAULT: 'DEFAULT',
  PROMO_NO_REFERENCE: 'PROMO_NO_REFERENCE',
  PROMO_DISCOUNTED: 'PROMO_DISCOUNTED',
  CHAIN_DISCOUNT: 'CHAIN_DISCOUNT',
  FAMILY: 'FAMILY',
};

export function buildCapsules(capsules = [], { discount, breakfast } = {}) {
  return [
    ...(discount?.length ? [{ type: CAPSULE_TYPES.DISCOUNT, text: discount }] : []),
    ...capsules,
    ...(breakfast ? [{ type: CAPSULE_TYPES.BREAKFAST, text: breakfast }] : []),
  ];
}
